import React, {useContext} from "react";
import {ACol, AContainer, ARow} from "@cisco-sbg-ui/magna-react";
import MultiSelectCheckbox from "components/MultiSelectCheckbox";
import {EntityListContext} from "contexts/EntityListContext";
import css from "./DrawerSelectAll.module.scss";

export default function DrawerSelectAll({selectName}) {
  const {data, selected, setSelected} = useContext(EntityListContext);

  return (
    <AContainer fluid className={css.listHeader}>
      <ARow noGutters className="align-center">
        <ACol cols="auto">
          <MultiSelectCheckbox
            isSelectAll
            disabled={data?.length === 0}
            data-testid="Drawer-SelectAll"
            allValues={data}
            {...{selected, setSelected}}
          />
        </ACol>
        {selectName && (
          <ACol cols="auto" className={css.selectName}>
            {selectName}
          </ACol>
        )}
      </ARow>
    </AContainer>
  );
}
